module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00080-fs8.83923f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00080-fs8.png
// module id = 233
// module chunks = 0